import { useEffect } from "react";
import { FieldValues, useFormContext } from "react-hook-form";

type FieldsWatcherProps<T extends FieldValues> = {
  onChange: (values: T) => void;
  debounce?: number;
};

//TODO: actually apply debounce.
export default function FieldsWatcher<T extends FieldValues>({
  onChange,
  debounce = 0,
}: FieldsWatcherProps<T>) {
  const { subscribe } = useFormContext<T>();

  useEffect(() => {
    const callback = subscribe({
      formState: {
        values: true,
      },
      callback: ({ values }) => {
        onChange(values as T);
      },
    });

    return () => callback();
  }, [subscribe]);

  return null;
}
